import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './app.tsx';
import { AuthProvider } from './auth.tsx';
import { StaleClientBanner } from './stale-client-banner.tsx';
import { handleStaleClientError } from './stale-client.ts';
import { themeTokens } from './theme-tokens.ts';
import './styles.css';

const queryClient = new QueryClient({
  // 部署瞬间的“旧前端 + 新后端”会让严格 schema 校验失败，这里自动刷新一次，避免 Zod 原始报错落到页面上。
  queryCache: new QueryCache({ onError: (error) => { handleStaleClientError(error); } }),
  defaultOptions: {
    queries: { retry: 1, staleTime: 10_000 },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          // 颜色统一取自 theme-tokens.ts，与 styles/09 的 :root 由测试保持一致
          colorPrimary: themeTokens.primary,
          colorInfo: themeTokens.info,
          colorSuccess: themeTokens.success,
          colorWarning: themeTokens.warning,
          colorError: themeTokens.danger,
          colorText: themeTokens.text,
          colorTextSecondary: themeTokens.textSecondary,
          colorBorder: themeTokens.border,
          colorBgLayout: themeTokens.bgLayout,
          colorBgContainer: themeTokens.bgContainer,
          borderRadius: 10,
          fontFamily: "'MiSans', 'PingFang SC', 'Microsoft YaHei', -apple-system, sans-serif",
        },
        components: {
          Button: { controlHeight: 38, fontWeight: 700, primaryShadow: 'none' },
          Card: { headerFontSize: 15 },
          Input: { controlHeight: 40 },
          Select: { controlHeight: 40 },
          Modal: { borderRadiusLG: 16 },
        },
      }}
    >
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider><App /></AuthProvider>
        </BrowserRouter>
        <StaleClientBanner />
      </QueryClientProvider>
    </ConfigProvider>
  </React.StrictMode>,
);
